module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHAQMAAAD+nMWQAAAABlBMVEX///8AAABVwtN+AAAAAXRSTlMAQObYZgAAABRJREFUeJxjUGAwYLBgsAFiAwYFAAkiAU0BY5PQAAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/menu-collapsed.png
 ** module id = 1472
 ** module chunks = 0
 **/